import axios from 'axios/index';

export const GET_PROSES_RAPOR = '[RAPOR MUTU] GET PROSES RAPOR';
export const GET_VERVAL_SEKOLAH = '[RAPOR MUTU] GET VERVAL SEKOLAH';
export const PROSES_RAPOR_MUTU = '[RAPOR MUTU] PROSES RAPOR MUTU';
export const HITUNG_FINAL_SKOR = '[RAPOR MUTU] HITUNG FINAL SKOR';
export const HITUNG_HASIL_SUBL = '[RAPOR MUTU] HITUNG HASIL SUBL';
export const HITUNG_HASIL_INDL = '[RAPOR MUTU] HITUNG HASIL INDL';
export const HITUNG_HASIL_STDL = '[RAPOR MUTU] HITUNG HASIL STDL';
export const HITUNG_MASTER_PMP = '[RAPOR MUTU] HITUNG MASTER PMP';
export const GET_RAPOR_MUTU_RADAR = '[RAPOR MUTU] GET RAPOR MUTU RADAR';
export const GET_RAPOR_MUTU = '[RAPOR MUTU] GET RAPOR MUTU';
export const GET_TIMELINE = '[RAPOR MUTU] GET TIMELINE';
export const SET_DATA_TAHUN = '[RAPOR MUTU] SET DATA TAHUN';
export const SET_DATA_WILAYAH = '[RAPOR MUTU] SET DATA WILAYAH';
export const SET_ACTIVE_STEP = '[RAPOR MUTU] SET ACTIVE STEP';
export const PROSES_DATAMART = '[RAPOR MUTU] PROSES_DATAMART';
export const PROSES_RAPOR_MUTU_DAPODIK = '[RAPOR MUTU] PROSES_RAPOR_MUTU_DAPODIK';
export const PROSES_SUB_INDIKATOR = '[RAPOR MUTU] PROSES_SUB_INDIKATOR';
export const PROSES_INDIKATOR = '[RAPOR MUTU] PROSES_INDIKATOR';
export const PROSES_STANDAR = '[RAPOR MUTU] PROSES_STANDAR';
export const PROSES_LOG_RAPOR = '[RAPOR MUTU] PROSES_LOG_RAPOR';
export const PROSES_NON_DATAMART = '[RAPOR MUTU] PROSES_NON_DATAMART';
export const CEK_SEKOLAH = '[RAPOR MUTU] CEK_SEKOLAH';

export function setDataTahun(data)
{
    return (dispatch) => {
        return dispatch ({
            type: SET_DATA_TAHUN,
            data_tahun: data
        })
    }
}

export function setDataWilayah(data)
{
    return (dispatch) => {
        return dispatch ({
            type: SET_DATA_WILAYAH,
            data_wilayah: data
        })
    }
}

export function setActiveStep(data)
{
    return (dispatch) => {
        return dispatch ({
            type: SET_ACTIVE_STEP,
            active_step: data
        })
    }
}

export function getRaporMutuRadar(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/getRaporMutuRadar', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_RAPOR_MUTU_RADAR,
                payload: response.data,
                routeParams
            })
        });
}

export function getRaporMutu(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/getRaporMutu', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_RAPOR_MUTU,
                payload: response.data,
                routeParams
            })
        });
}

export function getTimeline(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/getTimeline', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_TIMELINE,
                payload: response.data,
                routeParams
            })
        });
}

export function hitungMasterPMP(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/hitungMasterPMP', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : HITUNG_MASTER_PMP,
                payload: response.data,
                routeParams
            })
        });
}

export function hitungHasilStdl(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/hitungHasilStdl', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : HITUNG_HASIL_STDL,
                payload: response.data,
                routeParams
            })
        });
}

export function hitungHasilIndl(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/hitungHasilIndl', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : HITUNG_HASIL_INDL,
                payload: response.data,
                routeParams
            })
        });
}

export function hitungHasilSubl(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/hitungHasilSubl', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : HITUNG_HASIL_SUBL,
                payload: response.data,
                routeParams
            })
        });
}

export function hitungFinalSkor(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/hitungFinalSkor', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : HITUNG_FINAL_SKOR,
                payload: response.data,
                routeParams
            })
        });
}

export function getProsesRapor(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/prosesRapor', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_PROSES_RAPOR,
                payload: response.data,
                routeParams
            })
        });
}

export function prosesRaporMutu(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/prosesRaporMutu', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : PROSES_RAPOR_MUTU,
                payload: response.data,
                routeParams
            })
        });
}


export function getVervalSekolah(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/vervalSekolah', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_VERVAL_SEKOLAH,
                payload: response.data,
                routeParams
            })
        });
}

export function prosesDatamart(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/prosesDatamart', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : PROSES_DATAMART,
                payload: response.data,
                routeParams
            })
        });
}

export function prosesRaporMutuDapodik(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/prosesRaporMutuDapodik', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : PROSES_RAPOR_MUTU_DAPODIK,
                payload: response.data,
                routeParams
            })
        });
}

export function prosesSubIndikator(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/prosesSubIndikator', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : PROSES_SUB_INDIKATOR,
                payload: response.data,
                routeParams
            })
        });
}

export function prosesIndikator(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/prosesIndikator', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : PROSES_INDIKATOR,
                payload: response.data,
                routeParams
            })
        });
}

export function prosesStandar(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/prosesStandar', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : PROSES_STANDAR,
                payload: response.data,
                routeParams
            })
        });
}

export function prosesLogRapor(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/prosesLogRapor', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : PROSES_LOG_RAPOR,
                payload: response.data,
                routeParams
            })
        });
}

export function prosesNonDatamart(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/prosesNonDatamart', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : PROSES_NON_DATAMART,
                payload: response.data,
                routeParams
            })
        });
}

export function cekSekolah(routeParams)
{

    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/cekSekolah', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : CEK_SEKOLAH,
                payload: response.data,
                routeParams
            })
        });
}



// WEBPACK FOOTER //
// ./src/store/actions/RaporMutu.actions.js